import {useIsUnderUserLimit} from 'entities/user';

const useCanCreateServerAlertRule = (): boolean => (
    useIsUnderUserLimit('server_alert_rules_max_count_limit', 'server_alert_rules_count')
);

export default useCanCreateServerAlertRule;
